import React from 'react';
import PropTypes from 'prop-types';

import '../styles.css';

const InlineErrorMessage = ({ message, isVisible }) => (
  <React.Fragment>
    {isVisible && (
    <div styleName="input-error" data-cy="Premium-Hem-Inline-Error">
      {message}
    </div>
    )}
  </React.Fragment>
);

InlineErrorMessage.propTypes = {
  message: PropTypes.string.isRequired,
  isVisible: PropTypes.bool,
};

export default InlineErrorMessage;
